import patternValidators from 'helpers/validators/pattern-validators';
import PropTypes from 'prop-types';

import { Input } from 'components/FormComponents';

export const Email = ({
  name,
  label,
  placeholder,
  disabled,
  register = () => {},
  validators = {},
  className,
  defaultValue,
  inputProps = {},
  error = '',
  noErrorMessage = false,
  compareEmailValidation = false,
  compareEmail = null,
  compareErrorMessage = '',
}) => {
  // Combine default email validation with any validators passed from parent
  const combinedValidators = {
    ...patternValidators.email,
    ...validators,
    ...(compareEmailValidation
      ? {
          validate: {
            ...(validators.validate || {}),
            compare: value => {
              const emailsToCompare = Array.isArray(compareEmail) ? compareEmail : [compareEmail];
              const lowerValue = value?.trim?.().toLowerCase?.();

              const isNotInArray = !emailsToCompare
                ?.map(e => e?.trim?.().toLowerCase?.())
                ?.includes(lowerValue);
              return isNotInArray || compareErrorMessage;
            },
          },
        }
      : {}),
  };

  return (
    <Input
      name={name}
      placeholder={placeholder}
      disabled={disabled}
      className={className}
      defaultValue={defaultValue}
      register={register}
      validators={combinedValidators}
      error={error}
      noErrorMessage={noErrorMessage}
      noPadding
      {...inputProps}
    />
  );
};

Email.propTypes = {
  name: PropTypes.string,
  label: PropTypes.string,
  autoComplete: PropTypes.string,
  placeholder: PropTypes.string,
  defaultValue: PropTypes.string,
  disabled: PropTypes.bool,
  className: PropTypes.string,
  register: PropTypes.func,
  required: PropTypes.bool,
  inputProps: PropTypes.object,
  error: PropTypes.string,
  noErrorMessage: PropTypes.bool,
  compareEmailValidation: PropTypes.bool,
  compareEmail: PropTypes.oneOfType([PropTypes.string, PropTypes.arrayOf(PropTypes.string)]),
  compareErrorMessage: PropTypes.string,
};
